import { Provider } from 'react-redux';
import store from './store';
import '@progress/kendo-theme-default/dist/all.css';
import './App.css';
import RenderRoutes from './router/routes';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from './views/error-fallback';
import { AuthProvider } from './contexts/auth-context';

const AppContent = () => {
  return <RenderRoutes />;
};

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Provider>
  );
};

export default withErrorBoundary(App, { fallback: ErrorFallback });
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
